import { AttendeesItemProps } from '../../components/AttendeesItem/AttendeesItem'
import fetchJSON from '../fetchJSON'
import getUserPhotoUrl from '@bt-react/libs/getUserPhotoUrl'
import { xssSanitize as sanitize } from '@bt-react/libs/sanitize'

export type AttendeesResponse = {
  attendees: AttendeesItemProps[]
  totalAttendees: number,
  isLoading: boolean
}

/**
 * Converts API object to AttendeesItem
 * @param entry 
 */
export function convertResultToAttendeesItem (entry, cloudinaryEnv = ''): AttendeesItemProps {

  const { userId, firstName, lastName, jobTitle, companyName, country, vendorId } = entry

  return {
    id: userId,
    img: vendorId ? getUserPhotoUrl(vendorId, '100', (cloudinaryEnv || process.env.CLOUDINARY_ENV)) : '',
    name: sanitize(`${firstName} ${lastName}`),
    position: jobTitle ?? '',
    company: companyName ?? '',
    basedIn: country ?? ''
  }

}

async function fetchAttendees (channelId = '', webcastId = '', pageIndex = 1, hostUrl = '', cloudinaryEnv = ''): Promise<AttendeesResponse> {

  if (!channelId || !webcastId) return null

  const { data } = await fetchJSON('fetchAttendees', `${hostUrl || process.env.HOST}/service/attendee-status/channel/${channelId}/webcast/${webcastId}/attendees?pageNo=${pageIndex}&pageSize=4`, { includeCredentials: true })

  return {
    attendees: data.attendees ? data.attendees.map((val) => convertResultToAttendeesItem(val, cloudinaryEnv)) : [],
    totalAttendees: data.totalAttendees,
    isLoading: false
  }

}

export default fetchAttendees
